import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";
/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// envoyer un message
export const create_message = async (payload, context) => {
  // const { target, message, type, studentId, classId, parentId, teacherId, staffId } = req.body;
  const response = await axios.post(
    apiPaths.baseUrl + `/api/message/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les messages pour un utilisateur spécifique
export const get_messages_for_user = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/message/recuperation`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les messages supprimés
export const get_deleted_message = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/message/supprime`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// récupérer les messages supprimés
export const get_archived_message = async (context) => {
  const response = await axios.get(apiPaths.baseUrl + `/api/message/archive`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// supprimer un message
export const delete_message = async (id_message, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/message/delete/${id_message}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// mettre à jour un message
export const update_message = async (id_message, payload, context) => {
  // const { target, message, type, studentId, classId, parentId, teacherId, staffId } = req.body;
  const response = await axios.put(
    apiPaths.baseUrl + `/api/message/update/${id_message}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
